import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import { PreWiringDevicesIncludedPipe } from './pre-wiring-devices-included.pipe';
import { FilterOutSelectedEnclosuresPipe } from './filter-out-selected-enclosures.pipe';
import { IsTherePreWiringDevicesPipe } from './is-there-pre-wiring-devices.pipe';
import { FilterOutSelectedItemsPipe } from './filter-out-selected-items.pipe';

@Pipe({
    name: 'preWiringProjectDevicesIncluded',
    standalone: false
})
export class PreWiringProjectDevicesIncludedPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            bomModelsAccessories: IBomModel[],
            selectedItems: number[],
            selectedItemsAccessories: number[],
            bomProjectAccessories: IBomModel[],
            selectedProjectAccessories: number[],
            selectedEnclosures: number[]): boolean {
    const filterBomProject = new FilterOutSelectedItemsPipe().transform(bomProjectAccessories, selectedProjectAccessories, 'id');

    return new PreWiringDevicesIncludedPipe().transform(
      new FilterOutSelectedEnclosuresPipe().transform(bomModels, selectedEnclosures),
      new FilterOutSelectedEnclosuresPipe().transform(bomModelsAccessories, selectedEnclosures),
      selectedItems, selectedItemsAccessories) || new IsTherePreWiringDevicesPipe().transform(filterBomProject);
  }

}
